import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './app-toggle-switch.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AppToggleSwitchComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AppToggleSwitchComponent implements ControlValueAccessor, OnInit {
  @Input() isChecked: boolean | string = false;
  @Input() isTrueFalseValue: boolean = true;
  @Input() isDisable: boolean = false;
  @Input()
  set isDisabled(value: boolean) {
    this.isDisable = value;
  }
  @Input() onIcon: string = '\uF00C';
  @Input() offIcon: string = '\uF00D';

  @Input() trueValue: string = 'YES';
  @Input() falseValue: string = 'NO';
  @Output() byChange = new EventEmitter<boolean | string>();

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() { }

  ngOnInit() {
  }

  writeValue(value: any): void {
    if (typeof value === 'boolean') {
      this.isChecked = value;
    } else {
      this.isChecked = value === this.trueValue;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    //this.onTouched = fn;
  }

  toggleSwitch(event: Event) {
    if (this.isTrueFalseValue) {
      const target = event.target as HTMLInputElement;
      this.isChecked = target.checked;
    }
    else {
      const target = event.target as HTMLInputElement;
      if (target.checked) {
        this.isChecked = this.trueValue;
      } else {
        this.isChecked = this.falseValue;
      }
    }
    this.onChange(this.isChecked);
    this.byChange.emit(this.isChecked);
   // this.onTouched();
  }

}

